import { createFileRoute, stripSearchParams } from '@tanstack/react-router'
import { ClinicsPage, clinicsSearchSchema } from '@/features/clinics'

/** S-02 Clinics (`q`, `status`, `page`; Frontend §7.1). */
export const Route = createFileRoute('/_authed/clinics/')({
  validateSearch: clinicsSearchSchema,
  search: { middlewares: [stripSearchParams({ status: 'all', page: 1 })] },
  component: function ClinicsRoute() {
    return <ClinicsPage search={Route.useSearch()} />
  },
})
